import { render, staticRenderFns } from "./barcodeMain.vue?vue&type=template&id=1547ef24&"
import script from "./barcodeMain.vue?vue&type=script&lang=js&"
export * from "./barcodeMain.vue?vue&type=script&lang=js&"
import style0 from "./barcodeMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports